import "../../assets/css/Common/ColumnDrawer.css";

export default function ColumnDrawer({
  open,
  onClose,
  columns,
  visibleColumns,
  toggleColumn,
  error,
}) {
  if (!open) return null;

  return (
    <div
      className="column-drawer-overlay"
      onClick={onClose}
    >
      <div
        className="column-drawer"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="column-drawer-header">
          <h3>Manage Columns</h3>

          <button
            className="column-close-btn"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <div className="column-drawer-body">
          {error && (
            <div className="column-error">
              {error}
            </div>
          )}

          {columns
            .filter(col => col.id !== "select")
            .map(col => (
              <label
                key={col.id}
                className="column-item"
              >
                <input
                  type="checkbox"
                  checked={visibleColumns.includes(col.id)}
                  onChange={() => toggleColumn(col.id)}
                />

                <span>
                  {typeof col.label === "string"
                    ? col.label
                    : col.id}
                </span>
              </label>
            ))}
        </div>
      </div>
    </div>
  );
}